/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CTA : SAVE BUTTON STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library))
export default theme => ({
	createEmbed: {
		'& .loader': {
			display: 'none',
			fontSize: '65%',
			marginRight: pxToEm(10)
			// marginTop: pxToEm(-20)
		},
		'&.state-creating-true': {
			'& .loader': {
				display: 'inline-block'
			}
		}
	}
});